import { PopconfirmButton } from '@/components/_SiteWide/PopconfirmButton'
import { Horizontal, Texto, Vertical, addCommasToNumber } from '@gravitate-js/excalibrr'
import { IconTrash } from '@tabler/icons-react'
import { Collapse, Flex } from 'antd'
import classNames from 'classnames'
import type { OrderStopAndMeta } from '../types'

export type StopCardProps = {
  active?: boolean
  disabled?: boolean
  handleDeleteDetour?: (detourId: string) => void
} & OrderStopAndMeta

export function StopCard({ type, stop, active, disabled, handleDeleteDetour }: StopCardProps) {
  const isDetour = type === 'detour'
  const primaryColor = type === 'load' ? 'primary' : 'error'
  const headerAppearance = active ? 'white' : isDetour ? 'hint' : primaryColor
  const textAppearance = active ? 'white' : isDetour ? 'hint' : 'default'
  return (
    <Horizontal
      style={{ flex: '1 1 auto' }}
      gap={4}
      className={classNames(`${type}-stop`, { active: active }, { disabled: disabled }, { 'no-load': isDetour })}
    >
      <Vertical verticalCenter style={{ overflow: undefined, flex: '1 0 auto' }}>
        <Texto appearance={headerAppearance} className='load-heading' weight={'bold'}>
          {isDetour ? 'NO LOAD' : type.toUpperCase()}
        </Texto>
        {type === 'drop' && stop.store_name ? (
          <Texto appearance={textAppearance}>
            <b>{stop.store_name}</b> ({stop.location_name})
          </Texto>
        ) : (
          <Texto weight='bold' appearance={textAppearance}>
            {stop.location_name}
          </Texto>
        )}
        <Texto category='label' appearance={textAppearance}>
          {stop.address}
        </Texto>
        <Texto category='label' appearance={textAppearance}>
          {stop.city} {stop.state}
        </Texto>

        {type === 'drop' && stop.site_notes && (
          <Horizontal className='site-notes'>
            <Collapse ghost size='small'>
              <Collapse.Panel key={'1'} header='Site Notes'>
                <Texto>{stop.site_notes}</Texto>
              </Collapse.Panel>
            </Collapse>
          </Horizontal>
        )}
      </Vertical>
      <Flex
        style={{ flex: '1 1 auto', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center', gap: '18px' }}
      >
        {type !== 'detour' ? (
          stop.details?.map((s, i) => {
            return (
              <Flex flex={'1 1 auto'} vertical style={{ maxWidth: '200px' }} key={i}>
                <Texto
                  appearance={active ? 'white' : primaryColor}
                  weight={'bold'}
                  align='right'
                  style={{ textTransform: 'uppercase' }}
                >
                  {s.product_name}
                </Texto>
                <Texto appearance={active ? 'white' : 'default'} weight='bold' align='right'>
                  {s.volume ? addCommasToNumber(s.volume) : null}
                </Texto>
              </Flex>
            )
          })
        ) : (
          <PopconfirmButton
            buttonProps={{
              icon: <IconTrash color='var(--gray-600)' size={18} />,
              appearance: 'outline',
              disabled: !stop.detour_id && !stop.temp_id && !!handleDeleteDetour,
            }}
            popconfirmProps={{
              title: (
                <Texto>
                  Are you sure you want to delete this <b>NO LOAD</b> stop?
                </Texto>
              ),
              okText: 'Yes',
              cancelText: 'No',
              placement: 'topRight',
            }}
            onConfirm={handleDeleteDetour ? () => handleDeleteDetour(stop.detour_id || (stop.temp_id ?? '')) : () => {}} // make sure that detour is added as a possible type
          />
        )}
      </Flex>
    </Horizontal>
  )
}
